import { GetReportsDetailResponseBody } from '../../types/generated/reports_get.response';
import apiEndpoints from '../../../apiEndpoints';
import { fetcher } from '../../utils/fetchers/fetcher';

export const requestReports = (
  ids: string,
  token: string | null,
  forceHeader?: string
): Promise<GetReportsDetailResponseBody> =>
  fetcher<GetReportsDetailResponseBody>(
    `${apiEndpoints.routes.reports}/${ids}`,
    'GET',
    token,
    forceHeader
  );
